import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getUserPhotos,
  getUserVideos,
  removeUserPhoto,
  removeUserVideo,
} from '../../api/filesApi';

export const fetchUserPhotos = createAsyncThunk(
  'FileList/fetchUserPhotos',
  async (userId, thunkAPI) => {
    try {
      const response = await getUserPhotos(userId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const fetchUserVideos = createAsyncThunk(
  'FileList/fetchUserVideos',
  async (userId, thunkAPI) => {
    try {
      const response = await getUserVideos(userId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const deleteUserPhotos = createAsyncThunk(
  'FileList/deleteUserPhotos',
  async (photoId, thunkAPI) => {
    try {
      const response = await removeUserPhoto(photoId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const deleteUserVideos = createAsyncThunk(
  'FileList/deleteUserVideos',
  async (videoId, thunkAPI) => {
    try {
      const response = await removeUserVideo(videoId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
